// extracted by mini-css-extract-plugin
export default {"wrapper":"Tabs_wrapper__v9oH8","inner":"Tabs_inner__app9V","tabButton":"Tabs_tabButton__J4AyQ","isActive":"Tabs_isActive__zFHsh"};